// import { RequireAutorization } from './routerAuth'

export default {
  name: 'Financial',
  path: '/financeiro/:period',
  component: () => import(/* webpackChunkName: "Financial" */ '@apps/financial/Index.vue'),
  meta: { title: 'Financeiro', subject: 'Financial', action: 'list' },
  children: [
    {
      path: ':id/servicos',
      name: 'FinancialShow',
      component: () => import(/* webpackChunkName: "Financial" */'@apps/financial/Show.vue'),
      meta: { title: 'Detalhes da Empresa', subject: 'Financial', action: 'read' },
    },
  ],
  // beforeEnter: RequireAutorization
}
